<template>
   <footer class="mc-select-footer" slot="footer">
       <slot></slot>
   </footer>
</template>
<script>
    export default {

    }
</script>


// WEBPACK FOOTER //
// src/components/base-select-footer.vue